import React from "react";

import styles from "./DashboardGrid.module.css";

function DashboardGrid({ children, columns = 4, className = "" }) {
  return (
    <div className={`${styles.grid} ${className}`} style={{ "--dashboard-columns": columns }}>
      {children}
    </div>
  );
}

export default DashboardGrid;